import React from 'react';
import './ShimmerInput.css';

const ShimmerInput = ({ ...props }) => {

    return <div className="shimmer shimmer-input" aria-hidden="true" />

};

export default ShimmerInput;